import React, { useState } from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import MenuIcon from '@mui/icons-material/Menu';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { Stack } from '@mui/material';
import { Link, useLocation } from 'react-router-dom';
import '../../styles/Header.scss';

interface Props {
	window?: () => Window;
}

const drawerWidth = 240;
const navItems = [
	{ name: 'Home', to: '/' },
	{ name: 'About Us', to: '/about-us' },
	{ name: 'Menu', to: '/menu' },
	{ name: 'Gallery', to: '/gallery' },
	{ name: 'Contact Us', to: '/contactus' },
];

export default function Header(props: Props) {
	const { window } = props;
	const [mobileOpen, setMobileOpen] = useState(false);

	const location = useLocation();

	const handleDrawerToggle = () => {
		setMobileOpen((prevState) => !prevState);
	};

	const isActive = (path: string) => location.pathname === path;

	const drawer = (
		<Box sx={{ textAlign: 'center', height: '25px' }}>
			<Typography
				variant="h6"
				sx={{ my: 2, display: 'flex', justifyContent: 'center', fontFamily: 'Poppins' }}
			>
				<a href="/">
					<img
						alt="Selli"
						src="assets/chakaravarthy-catering-logo.png"
						style={{ width: 90, height: 'auto' }}
					/>
				</a>
			</Typography>
			<Divider />
			<List>
				{navItems.map((item) => (
					<Link
						to={item.to}
						key={item.name}
						style={{ textDecoration: 'none', color: 'inherit' }}
						onClick={handleDrawerToggle}
					>
						<ListItem disablePadding>
							<ListItemButton sx={{ textAlign: 'center', fontFamily: 'Poppins' }}>
								<ListItemText primary={item.name} />
							</ListItemButton>
						</ListItem>
					</Link>
				))}
			</List>
		</Box>
	);

	const container = window !== undefined ? () => window().document.body : undefined;

	return (
		<Box
			sx={{
				display: 'flex',
				fontFamily: 'Poppins',
			}}
		>
			<CssBaseline />
			<AppBar
				component="nav"
				className="backgorun-color-main"
				sx={{
					backgroundColor: '#fff',
					color: '#000',
					position: 'fixed',
					top: 0,
					zIndex: 1200,
					boxShadow: `0px 5.81px 13.56px -1.94px #0E0D0D3D`,
					height: { xs: 'auto', sm: 'auto', md: '90px' },
				}}
			>
				<Toolbar
					sx={{
						display: 'flex',
						justifyContent: { xs: 'space-between', md: 'space-between' },
						alignItems: 'center',
						textAlign: 'end',
					}}
				>
					<IconButton
						color="inherit"
						aria-label="open drawer"
						edge="start"
						onClick={handleDrawerToggle}
						sx={{ mr: 2, display: { md: 'none' }, color: '#000' }}
					>
						<MenuIcon />
					</IconButton>
					<Typography
						variant="h6"
						component="div"
						sx={{
							flexGrow: 1,
							display: { xs: 'block', md: 'block' },
							marginRight: '20px',
							textAlign: { xs: 'center', lg: 'start' },
						}}
					>
						<a href="/">
							<img
								alt="Selli"
								src="/assets/chakaravarthy-catering-logo.png"
								style={{ width: 117, height: 'auto' }}
							/>
						</a>
					</Typography>
					<Stack
						direction="row"
						spacing={1}
						sx={{
							display: { xs: 'none', md: 'block' },
							alignItems: 'center',
							justifyContent: 'flex-end',
							width: '100%',
						}}
					>
						<Box
							sx={{ display: { xs: 'none', sm: 'block', width: 'auto' } }}
							className="header-toolbar-section"
						>
							{navItems.map((item) => (
								<Link
									to={item.to}
									style={{
										textDecoration: 'none',
										color: isActive(item.to) ? '#CD3131' : 'black',
									}}
									key={item.name}
								>
									<Button
										key={item.name}
										sx={{
											color: isActive(item.to) ? '#CD3131' : '#000',
											fontFamily: 'Poppins',
											textTransform: 'none',
											fontSize: '16px',
											fontWeight: 500,
											'&:hover': {
												backgroundColor: '#fff',
												textDecoration: 'underline',
												textUnderlineOffset: '8px',
												textDecorationColor: '#CD3131',
												textDecorationThickness: '2px',
											},
										}}
									>
										<Link
											to={item.to}
											style={{
												textDecoration: 'none',
												color: isActive(item.to) ? '#CD3131' : 'black',
											}}
										>
											{item.name}
										</Link>
									</Button>
								</Link>
							))}

							<Link
								to="/customized-menu"
								style={{
									textDecoration: 'none',
								}}
							>
								<Button variant="contained" color="primary">
									Get Quotation
								</Button>
							</Link>
						</Box>
					</Stack>
				</Toolbar>
			</AppBar>
			<nav>
				<Drawer
					container={container}
					variant="temporary"
					open={mobileOpen}
					onClose={handleDrawerToggle}
					ModalProps={{
						keepMounted: true,
					}}
					sx={{
						display: { sm: 'block', md: 'none' },
						'& .MuiDrawer-paper': {
							boxSizing: 'border-box',
							width: drawerWidth,
							fontFamily: 'Poppins',
						},
					}}
				>
					{drawer}
				</Drawer>
			</nav>
		</Box>
	);
}
